export type TabGroup = {
  id: string;
  title: string;
  icon: string;
};

export const tabGroups: TabGroup[] = [
  { id: "overview", title: "Overview", icon: "home" },
  { id: "trading-system", title: "Trading System", icon: "chart" },
  { id: "ai-center", title: "AI Center", icon: "cpu" },
  { id: "connections-data", title: "Connections & Data", icon: "link" },
  { id: "subscriptions", title: "Subscriptions & Users", icon: "users" },
  { id: "operations", title: "Operations", icon: "settings" },
  { id: "trading-controls", title: "Trading Controls", icon: "target" },
];

export type DashboardTab = {
  id: string;
  title: string;
  description: string;
  group: string;
};

export const dashboardTabs: DashboardTab[] = [
  {
    id: "overview",
    title: "Overview",
    description: "Quick KPIs, active signals, and system highlights.",
    group: "overview",
  },
  {
    id: "trading-system",
    title: "Trading System",
    description: "Central control for AI-driven trading, positions, and risk.",
    group: "trading-system",
  },
  {
    id: "connections",
    title: "Connections",
    description: "Administer news providers, AI backends, and infrastructure links.",
    group: "connections-data",
  },
  {
    id: "integrations",
    title: "Integrations",
    description: "Link personal trading accounts, Telegram alerts, and webhooks.",
    group: "connections-data",
  },
  {
    id: "market-data",
    title: "Market Data",
    description: "Depth, execution feed, and curated headlines for active symbols.",
    group: "connections-data",
  },
  {
    id: "ai-assistant",
    title: "AI Assistant",
    description: "Conversational interface, memory tools, and knowledge uploads.",
    group: "ai-center",
  },
  {
    id: "ai-supervisor",
    title: "AI Supervisor",
    description: "Admin oversight, automation guardrails, and AI performance telemetry.",
    group: "ai-center",
  },
  {
    id: "user-trading-system",
    title: "My Trading",
    description: "Control your personal trading settings and view your trading statistics.",
    group: "trading-system",
  },
  {
    id: "trading-logic-controls",
    title: "Entry & Filter Settings",
    description: "Configure entry gates, sniper, signal filters, and trading logic.",
    group: "trading-controls",
  },
  {
    id: "trade-flow-tracking",
    title: "Trade Flow Tracking",
    description: "Comprehensive pipeline tracking: 12 stages from platform fetch to execution and journey timeline.",
    group: "trading-controls",
  },
  {
    id: "admin-trading-pipeline",
    title: "Trading Master Switches",
    description: "Enable/disable trading, entries, exits, and signals system-wide.",
    group: "trading-controls",
  },
  {
    id: "admin-trade-execution",
    title: "Trade Execution",
    description: "Execute entry and exit trade operations directly from admin panel.",
    group: "trading-controls",
  },
  {
    id: "admin-trade-history",
    title: "Trade History",
    description: "View historical trade records and execution details.",
    group: "trading-controls",
  },
  {
    id: "system",
    title: "System",
    description: "Global settings, risk controls, and audit logs.",
    group: "operations",
  },
  {
    id: "users",
    title: "Users",
    description: "Manage user accounts, roles, and access control.",
    group: "subscriptions",
  },
  {
    id: "plans",
    title: "Plans",
    description: "Manage trading plans and daily trade caps.",
    group: "subscriptions",
  },
  {
    id: "subscriptions",
    title: "Subscriptions",
    description: "Manage user subscriptions to trading plans.",
    group: "subscriptions",
  },
  {
    id: "support",
    title: "Support",
    description: "Create and manage support tickets.",
    group: "trading-system",
  },
  {
    id: "admin-operations",
    title: "Business Operations",
    description: "Admin operations dashboard with metrics and statistics.",
    group: "operations",
  },
  {
    id: "admin-support",
    title: "Support Management",
    description: "Manage all support tickets and respond to user inquiries.",
    group: "subscriptions",
  },
  {
    id: "admin-coins-wallets",
    title: "Coins & Wallets",
    description: "Manage supported cryptocurrencies and wallet addresses.",
    group: "subscriptions",
  },
  {
    id: "admin-payment-monitoring",
    title: "Payment Monitoring",
    description: "Monitor payment intents and payments with verification controls.",
    group: "subscriptions",
  },
  {
    id: "admin-dlq",
    title: "DLQ Monitor",
    description: "View and analyze failed execution jobs in the Dead Letter Queue.",
    group: "operations",
  },
  {
    id: "admin-exit-signals",
    title: "Exit Signals",
    description: "Monitor and manage exit signals for subscribers who failed to exit after admin exit.",
    group: "trading-controls",
  },
  {
    id: "admin-health-ops",
    title: "Infrastructure Health",
    description: "Worker health status, queue metrics, and operational health monitoring.",
    group: "operations",
  },
  {
    id: "admin-system-storage",
    title: "Storage & Logs",
    description: "View disk usage and manage backend log files: download or delete manually.",
    group: "operations",
  },
  {
    id: "admin-metrics",
    title: "Metrics",
    description: "Detailed metrics including entry gate, queue lag, reconciliation, and orphan linking.",
    group: "operations",
  },
  {
    id: "admin-controls",
    title: "Controls",
    description: "Trading kill switches and global system controls.",
    group: "trading-controls",
  },
  {
    id: "admin-diagnostics",
    title: "Diagnostics & Archive",
    description: "Archived exit signals, DLQ monitoring, and diagnostic tools.",
    group: "operations",
  },
  {
    id: "admin-reconciliation",
    title: "Reconciliation",
    description: "Monitor stuck jobs, outbox, and order intents requiring reconciliation.",
    group: "operations",
  },
  {
    id: "admin-positions-monitor",
    title: "Positions Monitor",
    description: "Per-position membership ledger, extend TTL, cleanup, force exit, rebuild.",
    group: "trading-controls",
  },
  {
    id: "ai-engine-monitor",
    title: "AI Engine",
    description: "Monitor AI Technical Engine shadow mode, comparison stats, and readiness for live transition.",
    group: "ai-center",
  },
  {
    id: "xgboost-control-center",
    title: "XGBoost",
    description: "XGBoost Control Center: ML observability, memory, training, models, and drift monitoring.",
    group: "ai-center",
  },
  {
    id: "lgbm-control-center",
    title: "LightGBM",
    description: "LightGBM Control Center: Advanced leaf-wise gradient boosting with enhanced 4H and OrderBook features.",
    group: "ai-center",
  },
];
